export default "<div [formGroup] = \"form\">\n\n<editor formControlName = \"ques\" id=\"fibtype\" ></editor></div>"